'use client';

import React from 'react';
import WelcomeHero from './WelcomeHero';
import StudentValueHighlights from './StudentValueHighlights';
import LearningProcess from './LearningProcess';
import SkillsRoleMapping from './SkillsRoleMapping';
import OutcomesStats from './OutcomesStats';
import StudentTestimonials from './StudentTestimonials';
import StudentCTA from './StudentCTA';

const StudentsInteractive: React.FC = () => {
    return (
        <div className="min-h-screen bg-background">

            <StudentValueHighlights />
            <LearningProcess />
            <SkillsRoleMapping />
            {/* <OutcomesStats /> */}
            {/* <StudentTestimonials /> */}
            {/* <StudentCTA /> */}

        </div>
    );
};

export default StudentsInteractive;